import { Routes } from '@angular/router';
import { FamilyCasesComponent } from './family-cases/family-cases.component';
import { CaseSearchComponent } from './case-search/case-search.component';

export const routes: Routes = [
	{ path: '', component: FamilyCasesComponent },
	{ path: 'search', component: CaseSearchComponent },
	{ path: '**', redirectTo: '' }
];


